export default __webpack_public_path__ + "static/12_21-aca96b06451ace9748ca3f26b0b1aa01.png";